import type { NavigateFunction } from "react-router";
import type { OpenWindowConfig } from "@/components/ui/os-layout/useWindow";

export type OpenTaskInMissionControlDeps = {
  navigate: NavigateFunction;
  openWindow: (config: OpenWindowConfig) => void;
  inOsLayout?: boolean;
};

/** Open a task thread in Mission Control (not the chat slide-over drawer). */
export function openTaskInMissionControl(
  taskId: string,
  { navigate, openWindow, inOsLayout = false }: OpenTaskInMissionControlDeps,
): void {
  if (inOsLayout) {
    openWindow({
      appId: "mission-control",
      title: "Mission Control",
      params: { taskId, view: "tasks" },
    });
    return;
  }
  navigate(`/tasks/${encodeURIComponent(taskId)}`);
}
